import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {IProcutatorList} from '../../../shared/interfaces/ISellerPj';
import {ErrorMessage} from '../../../shared/models/error-message';
import {SellerPJDataPayload} from "../../../shared/models/sellerPj.model";
import {
  mapFormToDataPersonalSellerPjThree,
} from "../../../utils/seller-pj-mapper.util";

@Component({
  selector: 'app-seller-step-three-pj',
  templateUrl: './seller-step-three-pj.component.html',
  styleUrls: ['./seller-step-three-pj.component.scss'],
})
export class SellerStepThreePjComponent implements OnInit {
  @Output() formsComplete = new EventEmitter();
  @Input() dataCompany = new SellerPJDataPayload();
  @Output() dataForms = new EventEmitter<SellerPJDataPayload>()

  listAccount: IProcutatorList[];

  formStepThree: FormGroup;
  value: number;

  getErrorInvalid(label: string): string {
    return ErrorMessage.getTextInvalid(label);
  }

  constructor() {
  }

  ngOnInit(): void {
    this.createListAccounts();
    this.initForm();
  }

  createListAccounts(): void {
    this.listAccount = [
      {
        name: this.dataCompany.corporateName,
        documentNumber: this.dataCompany.documentNumber!
      },
      ...this.dataCompany.representatives
    ];
  }

  initForm() {
    this.formStepThree = new FormGroup({});
  }

  reciverCurrentAccounts(currentAccountsData: FormGroup) {
    const formValue = currentAccountsData.getRawValue();
    this.formsComplete.emit(currentAccountsData.status === 'VALID');
    Object.assign(this.dataCompany, mapFormToDataPersonalSellerPjThree(formValue));
    this.dataForms.emit(this.dataCompany);
  }
}
